import { BASE_TITLE, BASE_TITLE_SEP } from '../constants';

export const getTitle = (text?: string) => {
  return text ? text + BASE_TITLE_SEP + BASE_TITLE : BASE_TITLE;
};
